module.exports = __webpack_public_path__ + "static/media/mailchimp-light.c21d32a0.png";